import "./circle-loader.scss";

interface Props {
	size?: string;
}

export const CircleLoader = ({ size }: Props) => {
	return (
		<div className={`loader ${size && size.length > 0 ? size : ""}`}></div>
	);
};
